import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import MoonFoxes from './artifacts/contracts/MoonFoxes.sol/MoonFoxes.json';
import './App.css';
import img1 from './img/1.png';
import img2 from './img/2.png';
import img3 from './img/3.png';
import img4 from './img/4.png';
import img5 from './img/5.png';
import img6 from './img/6.png';
import img7 from './img/7.png';
import img8 from './img/8.png';
import img9 from './img/9.png';
import img10 from './img/10.png';

const MFXaddress = "0xed0A40e8d902014cf28B46C75B5ae239e9F53565";

function App() {

  const [error, setError] = useState('');
  const [data, setData] = useState({});
  const [accounts, setAccount] = useState([]);


  useEffect(() => {
    fetchData();
    getAccounts();
  }, [])

  async function getAccounts() {
    if(typeof window.ethereum !== 'undefined') {
      let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
      setAccount(accounts);
      console.log("owner: " + accounts[0]);
    }
  }

  async function fetchData() {
    if(typeof window.ethereum !== 'undefined') {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const contract = new ethers.Contract(MFXaddress, MoonFoxes.abi, provider);
      try {
        const cost = await contract.cost();
        const totalSupply = await contract.totalSupply();
        const object = {"cost": String(cost), "totalSupply": String(totalSupply)}
        setData(object);
      }
      catch(err) {
        setError(err.message);
      }
    }
  }

  async function mint() {
    if(typeof window.ethereum !== 'undefined') {
      let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(MFXaddress, MoonFoxes.abi, signer);
      try {
        let overrides = {
          from: accounts[0],
          value: data.cost
        }
        const transaction = await contract.mint(accounts[0], 1, overrides);
        await transaction.wait();
        fetchData();
      }
      catch(err) {
        setError(err.message);
      }
    }
  }

  async function withdraw() {
    if(typeof window.ethereum !== 'undefined') {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(MFXaddress, MoonFoxes.abi, signer);
      try {
        const transaction = await contract.withdraw();
        await transaction.wait();
      }
      catch(err) {
        setError(err.message);
      }
    }
  }

  return (
    <div className="App">
      {accounts[0] === "0xf6a5d5ccc7ba0ab32173bb3e6216760ba2b1ba12" && <button className="withdraw" onClick={withdraw}>Withdraw</button>}
      <div className="container">
        <div className="banniere">
          <img src={img1} alt="img" />
          <img src={img2} alt="img" />
          <img src={img3} alt="img" />
          <img src={img4} alt="img" />
          <img src={img5} alt="img" />
          <img src={img6} alt="img" />
          <img src={img7} alt="img" />
          <img src={img8} alt="img" />
          <img src={img9} alt="img" />
          <img src={img10} alt="img" />
        </div>
        {error && <p>{error}</p>}
        <h1>Mint a Moon Fox NFT !</h1>
        <p className="count">{data.totalSupply} / 20</p>
        <p className="cost">Each Moon Fox NFT costs {data.cost / 10**18} eth (excluding gas fees)</p>
        <button onClick={mint}>BUY one Moon Fox NFT</button>
        <p className="cost">To see your NFTs in Metamask, click on "Import tokens" and paste this address: 0x108DF786fC4E755070A064598A32FA1Aa4De8A00</p> 
        <p className="cost">Symbol will automatically set to MFX</p>
        <p className="cost">Set Decimals to 0, and import.</p>  
      </div>
    </div>
  );
}

export default App;